import React, { PureComponent } from "react";
import { Form, Input, Button, Alert, notification } from "antd";
import _ from "lodash";
import { withRedux } from "../../hoc";
import { registerAction } from "../../actions/auth";

const FormItem = Form.Item;

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {
  registerAction
};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class RegisterForm extends PureComponent {
  state = {
    submitting: false,
    errorMessage: null
  };
  register = async values => {
    const { t } = this.props;
    if (this.state.submitting) return false;
    this.setState({ submitting: true, errorMessage: null });
    const data = {
      ...values,
      username: values.email
    };
    const registerResult = await this.props.actions.registerAction(data);
    if (_.get(registerResult, "status") === "error") {
      this.setState({ errorMessage: _.get(registerResult, "message"), submitting: false });
      return false;
    }
    notification.success({
      message: t("Register Success")
    });
    this.setState({ submitting: false });
    this.props.form.resetFields();
    this.props.onRegistered();
    return true;
  };
  handleSubmitRegister = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.register(values);
      }
    });
  };
  render() {
    const { message, t } = this.props;
    const { submitting, errorMessage } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <React.Fragment>
        {errorMessage && <Alert message={errorMessage} type="warning" showIcon closable />}
        {message && <Alert message={message} type="warning" showIcon closable />}
        <Form onSubmit={this.handleSubmitRegister} className="register-form">
          <FormItem colon={false} label={t("Full Name")}>
            {getFieldDecorator("fullname", {
              rules: [{ required: true, message: t("Please input your Name!") }]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Email Address")}>
            {getFieldDecorator("email", {
              rules: [
                {
                  type: "email",
                  message: t("The input is not valid Email!")
                },
                {
                  required: true,
                  message: t("Please input your Email!")
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Mobile Number")}>
            {getFieldDecorator("mobile", {
              rules: [{ required: true, message: t("Please input your Mobile Number!") }]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Company")}>
            {getFieldDecorator("company")(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Set Password")}>
            {getFieldDecorator("password", {
              rules: [{ required: true, message: t("Please input your Password!") }]
            })(<Input type="password" />)}
          </FormItem>
          <FormItem style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              className="register-form-button"
              loading={submitting}
            >
              {t("Register")}
            </Button>
          </FormItem>
        </Form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/RegisterForm.js